import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';

import { LayoutModule } from './views/layout/layout.module';
import { AuthGuard } from './core/guard/auth.guard';

import { AppComponent } from './app.component';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';

import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { JwtModule } from '@auth0/angular-jwt';
import { environment } from '../environments/environment';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppInterceptor } from './core/service/app-interceptor';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { AuthService } from './core/service/auth.service';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import localeEn from '@angular/common/locales/en';
import localeEnExtra from '@angular/common/locales/extra/en';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { registerLocaleData } from '@angular/common';
import { NgbAccordionModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatterService } from './core/service/custom-date-parser-formatter.service';
import { provideApiConfiguration } from "@xfeet-workspace/xfeet-api-client";
import { TranslateModule } from '@ngx-translate/core';

registerLocaleData(localeFr, 'fr', localeFrExtra);
registerLocaleData(localeEs, 'es', localeEsExtra);
registerLocaleData(localeEn, 'en', localeEnExtra);
registerLocaleData(localeDe, 'de', localeDeExtra);
export function getTokenFromStorage() {
  return localStorage.getItem('token');
}

@NgModule({ declarations: [
      AppComponent,
      ErrorPageComponent,
    ],
    bootstrap: [AppComponent], imports: [
      BrowserModule,
      AppRoutingModule,
      LayoutModule,
      NgxSpinnerModule,
      NgbAccordionModule,
      ToastrModule.forRoot(),
      JwtModule.forRoot({
          config: {
              headerName: environment.authHeaderName,
              allowedDomains: [environment.apiHost],
              disallowedRoutes: [
                  (environment.proxy ? '' : environment.apiRootUrl) + '/api/auth/login',
                  (environment.proxy ? '' : environment.apiRootUrl) + '/api/languages',
                  (environment.proxy ? '' : environment.apiRootUrl) + '/api/titles',
                  (environment.proxy ? '' : environment.apiRootUrl) + '/api/transaction',
              ],
              authScheme: '',
              tokenGetter: getTokenFromStorage,
              throwNoTokenError: false
          }
      }),
      TranslateModule.forRoot()
      ],
      providers: [
        provideTranslateHttpLoader({
          prefix: 'assets/i18n/',
          suffix: '.json?' + new Date().getTime().toString(10)
        }),
      provideApiConfiguration(environment.apiRootUrl),
      {
          provide: LOCALE_ID,
          deps: [AuthService], // some service handling global settings
          useFactory: (authService: AuthService) => authService.getLocale()
      },
      { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
      AuthGuard,
      {
          provide: HIGHLIGHT_OPTIONS, // https://www.npmjs.com/package/ngx-highlightjs
          useValue: {
              coreLibraryLoader: () => import('highlight.js/lib/core'),
              languages: {
                  xml: () => import('highlight.js/lib/languages/xml'),
                  typescript: () => import('highlight.js/lib/languages/typescript'),
                  scss: () => import('highlight.js/lib/languages/scss'),
              }
          }
      },
      {
          provide: NgbDateParserFormatter,
          useClass: CustomDateParserFormatterService,
      },
      provideHttpClient(withInterceptorsFromDi()),
  ] })
export class AppModule { }
